export interface MovableCardsContainerViewModel<T extends string = string> {
  groups: (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[];
}

export interface MovableCardsContainerCardViewModel<T extends string = string> {
  key: T;
}

export interface MovableCardsContainerSingleColumnGroup<T extends string = string> {
  type: MovableCardsContainerGroupTypeEnum.SingleColumn;
  cards: MovableCardsContainerCardViewModel<T>[];
}

export interface MovableCardsContainerTwoColumnsGroup<T extends string = string> {
  type: MovableCardsContainerGroupTypeEnum.TwoColumns;
  leftCards: MovableCardsContainerCardViewModel<T>[];
  rightCards: MovableCardsContainerCardViewModel<T>[];
}

export enum MovableCardsContainerGroupTypeEnum {
  TwoColumns = 'two-columns',
  SingleColumn = 'single-column',
}

export interface SimpleDomRect {
  width: number;
  height: number;
  top: number;
  left: number;
}

export interface DragArea<T extends string = string> {
  top: number;
  left: number;
  width: number;
  height: number;
  swapFn: () => (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[];
}
